import React, { Fragment, useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import * as HttpStatus from 'http-status-codes';
import Modal from '../../shared/components/Modal';
import LogInForm from './components/LogInForm';
import { login, isAuthenticated } from '../../auth';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import loginAxios from '../../smartloginaxios';
import survey from '../../shared/queries/Survey';
import SmartContext from '../App/context/SmartContext';
import GraphQL from '../../GraphQL';
import AccessFormWrapper from './components/AccessFormWrapper';
import AccessImageWrapper from './components/AccessImageWrapper';

const LogIn = (props) => {
  const { dispatch, history, t } = props;
  const [hasError, setHasError] = useState(false);
  const context = useContext(SmartContext);
  const { setSurvey } = context;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setHasError(!hasError);
  };

  const loadSurvey = () => {
    const query = survey();
    GraphQL(query, {})
      .then((res) => {
        if (res.survey) {
          setSurvey({
            ...res.survey,
            deny: false,
          });
        } else {
          setSurvey(null);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const loginHandler = (values) => {
    const formData = new FormData();
    showLoading();
    formData.append('login', values.login);
    formData.append('password', values.password);
    loginAxios
      .post('login', formData)
      .then((res) => {
        if (res.data) {
          login(res.data);
          loadSurvey();
          history.push('/minime/dashboard');
          hideLoading();
        } else {
          toggleModal();
          hideLoading();
        }
      })
      .catch((error) => {
        console.error('loginHandler -> error', error);
        if (error.response) {
          if (
            error.response.status === HttpStatus.FORBIDDEN ||
            error.response.status === HttpStatus.UNAUTHORIZED
          ) {
            toggleModal();
          }
        }
        hideLoading();
      });
  };

  useEffect(() => {
    if (isAuthenticated()) {
      history.push('/minime/dashboard');
    }
  }, []);

  return (
    <Fragment>
      <Modal
        color="danger"
        title={t('notifications.error')}
        btn="Warning"
        message={t('general.invalid-user-password')}
        toggle={toggleModal}
        modal={hasError}
      />
      <div className="account">
        <AccessFormWrapper>
          <LogInForm onSubmit={loginHandler} />
        </AccessFormWrapper>
        <AccessImageWrapper />
      </div>
    </Fragment>
  );
};

LogIn.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(LogIn)
);
